import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import rostrud from "../../../images/ministrys/Emblem_of_Rostrud.svg.png";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function Vacancies() {
  useSEO(seoConfig.vacancies);

  return (
    <section className="vacancies">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Вакансии
      </h1>
      <div>
        <div className="licenses__blank">
          <h4 className="directions__more-title licenses__text">
            <li>Работа России</li>
          </h4>

          <img src={rostrud} alt="Работа России" className="controls__image" />

          <div className="licenses__blank-link">
            <a
              href="https://trudvsem.ru/company/1026605770058"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>

          <h4 className="directions__more-title licenses__text">
            <li>Анкета для увольняющегося сотрудника</li>
          </h4>

          <div className="licenses__blank-link">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLScOlwXmWqNOAG6PuLc8Dn-F00TJIF5unzS0Q64JB4yPWf67dg/viewform?usp=send_form"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
